(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 9494:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4186);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ App; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1753);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9618);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1993);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2646);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1902);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7140);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1456);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9684);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6648);
/* harmony import */ var _components_Navigation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5794);
/* harmony import */ var _components_TopNavigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4210);





function Breadcrumbs() {
    const breadcrumbItems = [
        {
            text: "Home",
            href: "/"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        items: breadcrumbItems,
        expandAriaLabel: "Show path",
        ariaLabel: "Breadcrumbs"
    });
}
function App() {
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TopNavigation__WEBPACK_IMPORTED_MODULE_3__/* .TopNav */ .t, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "h1",
                        info: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "info",
                            ariaLabel: "Information about Fire Kit Tools."
                        }),
                        actions: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            variant: "primary",
                            children: "Get started"
                        }),
                        children: "Fire Kit Tools"
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        size: "m",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                variant: "h1",
                                children: "Fire Kit Tools"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    size: "s",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "Start editing to see some magic happen"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            value: value,
                                            onChange: (event)=>setValue(event.detail.value)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            variant: "primary",
                                            children: "Click me"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                headerSelector: "#header",
                breadcrumbs: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Breadcrumbs, {}),
                navigation: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Navigation__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W, {})
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [996,990,774,888,179], function() { return __webpack_exec__(9494); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);